module.exports = __webpack_public_path__ + "img/iv_b4_img4.b616cc80.png";